import r from "./restArguments.js";
import t from "./_flatten.js";
import n from "./bind.js";
var o = r(function (r, o) {
  var e = (o = t(o, !1, !1)).length;
  if (e < 1) throw Error("bindAll must be passed function names");
  for (; e--;) {
    var s = o[e];
    r[s] = n(r[s], r);
  }
  return r;
});
export { o as default };